export const SELECT_ITEM = 'ALERTING_SELECT_ITEM';

export const selectItem = id => ({
  type: SELECT_ITEM,
  id,
});
